// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-create-general',
//   templateUrl: './create-general.component.html',
//   styleUrls: ['./create-general.component.scss']
// })
// export class CreateGeneralComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {
//   }

// }

import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { CommonServiceService } from 'src/app/shared/common-service.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker/ngx-bootstrap-datepicker';
import { Router } from '@angular/router';
import { CookiesService } from 'src/app/shared/cookies.service';



@Component({
    selector: 'app-create-general',
    templateUrl: './create-general.component.html',
    styleUrls: ['./create-general.component.scss']
  })
export class CreateGeneralComponent implements OnInit {

	baseUrl = environment.okountUrl;

  submitted = false;
  generalForm : FormGroup;
  groupList: any;
  showMessage: boolean = false;
	alertType  = '';
	message: string  = ``;
  createdGeneralId = ""
  createdGeneralCode = ""
  stateArr: any = [];
  newGeneral: boolean = true;
  isTenantIndian: boolean = false;
  remainingAmount = 0
    amountType = 'credit'
	vatAlternetname: string = 'VAT'
	isHQCompany: boolean = false;
	isAadesh: boolean = false

  isHQBranch : boolean = false
  @ViewChild('confirmModal',{static:true}) confirmModal : ElementRef
	@ViewChild('closeModal',{static:true}) closeModal : ElementRef
	@ViewChild("openSuccessModal", { static: true }) openSuccessModal: ElementRef;
	@ViewChild('confirmUpdateModal',{static:true}) confirmUpdateModal : ElementRef;
    @ViewChild('closeUpdateModal',{static:true}) closeUpdateModal : ElementRef;
	branches = []
	companies = []
  constructor(private fb: FormBuilder, private spinner: NgxSpinnerService,
    public commonService: CommonServiceService, private router: Router,
	private cookieService : CookiesService ) { 

    }

  async ngOnInit() {
    this.spinner.show(); 
    setTimeout(() => {		   
      this.spinner.hide();
    }, 1000);

    this.generalForm = this.fb.group({
      parent_id : ['' , Validators.required],
      account_name : ['' , Validators.required] ,
      hsn_code : [''],
      balance : [''],
      balance_type: ['debit'],
      state_id : [''],
	  state_name : [''],
      gst_number: [''],
	  vat_number: [''],
	  hierarchy: [''],
	  sync_in_branches: [''],
	  account_type: [''],
	  currency_rate:[''],
		local_balance: [''],
		currency:[''],
		branch:{},
		company:{}
    })
    this.getStates('101')
    this.getGroups()
	
	this.isTenantIndian = this.commonService.checkTenantIndian()

	this.isHQCompany = this.commonService.checkHQCompany()
		if(this.isHQCompany==true){
			this.getAllCompanys()
		}
	this.isHQBranch =await this.commonService.checkHQBranch()
	if(this.isHQBranch==true){
		this.getAllBranches()
		
		// this.branchForm = this.fb.group({
		// 	formObj
		// })
	}
	if(!this.isTenantIndian){
		let globalSettingConfig = this.commonService.globalSettingConfig;
	if(!globalSettingConfig || globalSettingConfig.length == 0) {
		globalSettingConfig = await this.commonService.getGlobalSettings();
	}
		let inv_config = globalSettingConfig.filter(el=>el.group=='VAT')
	if(inv_config.length){
		let vat_config = inv_config[0].json_doc.value.filter(el=>el.key=='vat_rate')
		let vat_detail,vat_name
		if(vat_config.length){
			 vat_detail = vat_config[0].value
		}
		if(vat_detail && vat_detail.length ){
			vat_name = vat_detail.filter(el=>el.key=='effective_name')
		}
		if(vat_name && vat_name.length){
			this.vatAlternetname = vat_name[0].value
		}
	}
	}

  }

  getStates(country_id) {
		this.commonService.getOkount(`location/states?country_id=${country_id}`).subscribe(res => {
			this.stateArr = res
		})
	}

  selectState(state_id) {
		let selectedState = this.stateArr.filter(option => {
			return option.location_id == Number(state_id);
		})
		if (selectedState.length > 0) {
			this.generalForm.controls.state_name.setValue(selectedState[0].name)
		}
	}

  openConfirmModal() :  void{
		this.confirmModal.nativeElement.click()
	}
	closeConfirmModal() :  void{
		this.closeModal.nativeElement.click()
	}

  reset() {
		this.generalForm.reset();
	  }

  submit(){

		this.submitted = true;
    this.closeConfirmModal()
	if(this.generalForm.controls.account_type.value=="INCOME" && !this.generalForm.controls.hsn_code.value){
		this.showMessage =true
			this.alertType = 'warning-box';
				this.message = 'FOR ACCOUNT TYPE "INCOME", HSN CODE IS MANDATORY'
			return false;
	}
		if(this.generalForm.valid){
      this.commonService.postRequest(`${this.baseUrl}/general`, this.generalForm.value).subscribe(res=>{
		this.updateOpeningBalanceAdjustAcc()
				this.showMessage =false
				this.newGeneral = false
				this.alertType = 'success-box';
				this.reset()
				this.createdGeneralId = res[0].id ? res[0].id : ""
				this.createdGeneralCode = res[0].account_code ? res[0].account_code : ""
				this.message = 'General saved successfully with account code. :'
				this.openSuccessModal.nativeElement.click()
				}, 
				error => {
				this.showMessage =true
				this.alertType = 'error-box';
				this.createdGeneralId = ""
				this.message = 'Failed to create General. Please try Again.'
				if(error.error && error.error.message=='duplicate key value violates unique constraint \"general_account_name_uk\"') this.message = 'GENERAL ALREADY EXIST'

			})
		}
		else {
			this.showMessage =true
			this.alertType = 'warning-box';
				this.message = 'Please fill mandatory fields.'
			return false;
		}
	}
 
  getGroups(){
		this.commonService.getOkount('v3account/getallsuperparents').subscribe(res=>{
			this.groupList = res
			console.log('Group list : ',this.groupList)
		},err=>{

		})
	}

  hideError(){
		this.showMessage = false
	}

	setHierarchy(parentId,onload){
		let hierarchy = this.generalForm.value.hierarchy
		let account_type= this.generalForm.value.account_type
		if(!onload || !hierarchy){
			let parentAccount = this.groupList && this.groupList.filter(data=> {
				return data.id == parentId
			})
			if(parentAccount && parentAccount.length > 0){
				hierarchy = Number(parentAccount[0].hierarchy)+1
				account_type = parentAccount[0].account_type
			}
		}
		this.generalForm.controls.hierarchy.setValue(hierarchy)
		this.generalForm.controls.account_type.setValue(account_type)

	}

	closeSuccesModal(){
		this.reset()
		this.newGeneral = true
		this.showMessage = false;
		this.alertType = 'success-box';
		this.message = ``
		this.openSuccessModal.nativeElement.click()
	}

	viewGeneral(general_id) {
		this.closeSuccesModal()
        this.router.navigate([`/master/general/update-general/${general_id}`])
	}

	changeCurrentAmount(event) {
		let currency = this.generalForm.controls.currency.value;
		let currency_rate = this.generalForm.controls.currency_rate.value;
		if(currency && currency_rate) {
			let local_balance = this.generalForm.controls.local_balance.value
			this.generalForm.controls.balance.setValue((Number(local_balance) / currency_rate).toFixed(2));
		} else {
			this.generalForm.controls.balance.setValue('')
		}
	}

	currencyChange(value){
		this.generalForm.controls.currency_rate.setValue('');
	
	}

	getAllBranches() {
        this.commonService.getOkount(`branch`).subscribe(res=> {
          if(res && res['data']) {
            this.branches = res['data'];
			let formObj = this.branches.reduce((acc,curr)=>{
				if(curr.branch_type=='BRANCH'){
					acc[curr.branch_name]=false
				}
				return acc
			},{})
			console.log("formObj",formObj)
			this.generalForm.controls.branch.setValue(formObj)
          }
        },err=> {
    
        })
      }

	  handleValueChange(e,branchName){
		console.log("branchName",this.generalForm.controls.branch)
		this.generalForm.controls.branch.value[branchName]=e.currentTarget.checked
	  }
	  async checkBalance(){
        let opening_amount = await  this.getOpeningBalanceData()
        if(this.generalForm.controls.balance_type.value=='debit') opening_amount['debit']= Number(opening_amount['debit']) + Number(this.generalForm.controls.balance.value)
        if(this.generalForm.controls.balance_type.value=='credit') opening_amount['credit']= Number(opening_amount['credit']) + Number(this.generalForm.controls.balance.value)
            console.log("opening_amount",opening_amount)
		if(this.cookieService.getCookie('SYSTACC_USER_LOGIN_DATA')) {
			let userData = JSON.parse(this.cookieService.getCookie('SYSTACC_USER_LOGIN_DATA'))
			if(userData && userData.tenant_id && (userData.tenant_id == environment.aadeshSystaccId || userData.tenant_id == environment.aadeshAedSystaccId)) {
				this.isAadesh = true;
			}
		}
        if(opening_amount && (opening_amount['debit']!=opening_amount['credit']) && this.isAadesh==false) {
            this.remainingAmount = Math.abs(Number((opening_amount['debit'] - opening_amount['credit']).toFixed(2)))
            this.amountType = opening_amount['debit']>opening_amount['credit'] ? 'credit' : 'debit'
			let res = await this.adjustAccOpeningBalance()
            if(res['balance']!=this.remainingAmount || this.amountType!=res['balance_type']){
                this.openUpdateConfirmModal()
			}else{
				this.updateOpeningBalancecombine()
			}
        }else{
            this.updateOpeningBalancecombine()
        }
    }

	adjustAccOpeningBalance(){
        return new Promise(async (resolve, reject) => {
        this.commonService.getRequestWithQueryParams(`${environment.okountUrl}/globalsearch/opening_balance`, {client: 'OB0000165'}).subscribe(res => {
            resolve(res)
        },err=>{
            console.log("err",err)
            resolve(null)
        })
    })
    }
	getOpeningBalanceData(){
        return new Promise(async (resolve, reject) => {
            this.commonService.getRequestWithQueryParamsNoLoader(`${environment.okountUrl}/globalsearch/openingBalanceTotal`, {}).subscribe(res => {
                resolve(res)
            },err=> {
                resolve(null)
            })
        })
    }
	openUpdateConfirmModal(){
		this.confirmUpdateModal.nativeElement.click()
	}
	 updateOpeningBalancecombine(){
        this.closeUpdateConfirmModal()
         this.submit()
    }
	closeUpdateConfirmModal(){
		this.closeUpdateModal.nativeElement.click()
	}
	updateOpeningBalanceAdjustAcc() {
        let req_body = {
            balance: this.remainingAmount,
            balance_type: this.amountType,
            account_code: 'OB0000165'
        }
        this.commonService.putRequest(`${environment.okountUrl}/client/updateOpeningBalanceAdjust`, req_body).subscribe(res => {
           
            console.log(res)
        }, err => {
        })

    }
	getAllCompanys() {
        this.commonService.getOkount(`company`).subscribe(res=> {
          if(res && res['data']) {
            this.companies = res['data'];
			let formObj = this.companies.reduce((acc,curr)=>{
				if(curr.associate_company_id!==null){
					acc[curr.tenant_company_name]=false
				}
				return acc
			},{})
			console.log("formObj",formObj)
			this.generalForm.controls.company.setValue(formObj)
          }
        },err=> {
    
        })
	}
	handleCompanyChange(e,companyName){
		console.log("companyName",this.generalForm.controls.company)
		this.generalForm.controls.company.value[companyName]=e.currentTarget.checked
	  }
		
		

}
